import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/* ================================
   ROLL MEDIA MESSAGING (Custom Element)
   Re-syncs the Lineal Metre callout from the re-rendered section
   on every variant change, the same way product-inventory does.
================================ */

class RollMediaMessaging extends HTMLElement {
  connectedCallback() {
    this.closestSection = this.closest('.shopify-section, dialog');
    this.closestSection?.addEventListener(
      ThemeEvents.variantUpdate,
      this.updateMessaging
    );
  }

  disconnectedCallback() {
    this.closestSection?.removeEventListener(
      ThemeEvents.variantUpdate,
      this.updateMessaging
    );
  }

  updateMessaging = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const newMessaging = event.detail.data.html?.querySelector(
      `roll-media-messaging[data-block-id="${this.dataset.blockId}"]`
    );

    if (!newMessaging) return;

    // morph childrenOnly leaves the host attributes alone, so sync visibility here
    this.hidden = newMessaging.hidden;
    morph(this, newMessaging, { childrenOnly: true });
  };
}

if (!customElements.get('roll-media-messaging')) {
  customElements.define('roll-media-messaging', RollMediaMessaging);
}
